"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPaymentClient = void 0;
var PaymentClient_1 = require("../PaymentClient");
function createPaymentClient(clientSettings, customerId) {
    if (customerId === void 0) { customerId = null; }
    return new PaymentClient_1.PaymentClientImpl(clientSettings, customerId);
}
exports.createPaymentClient = createPaymentClient;
//# sourceMappingURL=index.js.map